/**
 * User: Shad
 * Date: 9/11/13
 */

"use strict";
var SoaModel = require('bunsen/models/SoaModel');
var CurrencyConversion = SoaModel.extend();

module.exports = CurrencyConversion;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/CurrencyConversion.js
// module id = 2035
// module chunks = 62